import { Spin, SpinProps } from 'antd'
import * as React from 'react'

interface Props extends Omit<SpinProps, 'spinning'> {
  loading?: boolean
}

const KSpin: React.FC<Props> = ({ loading, children }) => {
  if (loading) return <Spin spinning={loading} tip={SpinTip} />

  return <>{children}</>
}

// Add progress bar element, so we can wait for loading during tests
export const SpinTip = <div role="progressbar"></div>

export default KSpin
